import confirmation from './confirmation'
import pageInitializationStatus from './pageInitializationStatus'
import {reducer as formReducer} from 'redux-form'

export default {confirmation, pageInitializationStatus, form: formReducer};



// WEBPACK FOOTER //
// ./src/app/reducers/index.js